import React, { useState, useEffect } from 'react'
import { width } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles'
import CustomTextInput from '../../../../CustomComponents/CustomtextInput'
import RightArrow from "../../../../../assets/images/RightArrow@2x.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../CustomComponents/Loader'
import DynamicCard from '../../../../CustomComponents/DynamicCard'
import { withOidcSecure } from '@axa-fr/react-oidc' 
import checkbox_fill from "../../../../../assets/images/Checkbox-blue.png"
import checkbox_null from "../../../../../assets/images/Checkbox-light.png"
import CustomRadioButton from '../../../../CustomComponents/CustomRadioButton'
import moment from 'moment'
import { GetApiHeadersWithBearer, PostRequest } from '../../../../../network/NetworkUtils'
import { addLineBreaks, dateComparison, retrieveData } from '../../../../../utils'
import { ADD_SPENDING_ALERT, SAVING_ALLOCATE_FUND,SAVING_ALLOCATE_FUND_V2, SAVING_CARD_CODE, STATUS_SUCCESS_CODE } from '../../../../../network/URLConstants'
import { getFrequencyAbbreviation } from '../../../../../utils'
import logFirebaseEvents from '../../../../LogFirebaseEvents'
import CardHeading from '../../../../CustomComponents/CardHeading'
import { appTheme } from '../../../../../helpers/utils/Utils'
import AllocateFundSubItemConfirmationCard from '../../SpendSenseAlerts/ConfirmationCard/AllocateFundSubItemConfirmationCard'
import CustomAllocateFundDropdown from '../../../../CustomComponents/CustomAllocateFundDropdown'
import CustomDatePicker from '../../../../CustomComponents/CustomDateInput'
import { displayErrorMessage } from '../../../../../utils'
import { GET_BALANACE_ALLOCATE } from '../../../../../network/URLConstants'
import { GetRequest } from '../../../../../network/NetworkUtils'

const AllocateConfirmationCard = ({ cardHeader, cardFooter, onBack, onEdit, onSave, onSetSpendSenseAlertFun }) => {

  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
  const appThemeData = appTheme(kudzuPlusTrue);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [NotificationError, setNotificationError] = useState('')
  const NotificationTypeSMS = useSelector(state => state.allocateFund.sms)
  const NotificationTypeEmail = useSelector(state => state.allocateFund.email)
  const [notificationArray, setNotificationArray] = useState([{ 'displayText': t('text'), 'isSelected': NotificationTypeSMS }, { 'displayText': t('email'), 'isSelected': NotificationTypeEmail }])
  const valueData = NotificationTypeSMS ? NotificationTypeSMS : NotificationTypeEmail ? NotificationTypeEmail : null;
  const styleForbuttons = "md:mr-[20px]"
 const setNotificationFun = (option) => { 
  setNotificationError(''); 
  const selectedIndex = notificationArray.findIndex(
    (item) => item.displayText === option.displayText
  );
 
  notificationArray[selectedIndex] = { 
    ...option, 
    isSelected: !option?.isSelected 
  };
  setNotificationArray([...notificationArray]);
 
  if (option.displayText === "Email") {
    dispatch({
      type: 'ALLOCATE_FUND',
      payload: { 
        key: 'email', 
        value: option?.isSelected !== undefined ? !option?.isSelected : valueData
      }
    });
  } else {
    dispatch({
      type: 'ALLOCATE_FUND',
      payload: { 
        key: 'sms', 
        value: option?.isSelected !== undefined ? !option?.isSelected : valueData
      }
    });
  }
};

 

  const AddedAmount = useSelector(state => state.allocateFund.Installments);
  const AddAccountType = useSelector(state => state.savingGoalAccountTypeObj);
  const Frequency = useSelector(state => state.allocateFund.Frequency);
  const selectedDateCopy = useSelector(state => state.allocateFund.TargetDate);
  // const StartDate=((new Date(selectedDateCopy).getDate() - new Date().getDate()) === 1) ? moment(selectedDateCopy).format('[Tomorrow], dddd, MMMM DD, YYYY') : moment(selectedDateCopy).format('dddd, MMMM DD, YYYY') 
  const StartDate=((new Date(selectedDateCopy).getDate() - new Date(new Date().toUTCString().substr(0, 25)).getDate()) === 1) ? moment(selectedDateCopy).format('[Tomorrow], dddd, MMMM DD, YYYY') : moment(selectedDateCopy).format('dddd, MMMM DD, YYYY') 
  
  const selectedStartDate = useSelector(state => state.allocateFund.StartDate)


  const selectedEndDate = useSelector(state => state.allocateFund.EndDate)
  // const selectedEndDate =  selectedEndDateCopy != undefined ? 
  //   new Date(selectedEndDateCopy).getDate() -
  //   new Date().getDate() ===
  // 1
  //   ? moment(selectedEndDateCopy).format("[Tomorrow], dddd, MMMM DD, YYYY")
  //   : moment(selectedEndDateCopy).format("dddd, MMMM DD, YYYY") :"";
    


  const targetdate = useSelector((state) => state.savingGoals.date);
  const savingGoalTargetDate = useSelector((state) => state.savingGoals.targetDate);
  const RequestObject = useSelector(state => state.spendAlertsPayload);
  const [activeIndex, setActiveIndex] = useState(-1); // Keep track of the active index
  const cards = useSelector(state => JSON.parse(state.userCards));
  const allocateFundData = useSelector(state => state.allocateFund);
  const accessToken = useSelector(state => state.accessToken);
  const SavingGaolName = useSelector(state => state.savingGoals.Name)
  const Saving_Goal = useSelector(state => state.savingGoals.name)
  const SavingGaolAmount = useSelector(state => state.savingGoals.amount)
  const { AccountType, AccountName, AccountId } = AddAccountType;
  const selectedFrequencyValueDATA = useSelector((state) => state.selectedFrequencyValue);
  const { Code, DisplayText } = selectedFrequencyValueDATA;
  const goalKeyData = useSelector(state => state.savingGoalResponseData.goalKey)
  const [selectedAccountType, setSelectedAccountType] = useState("")
  const accountObj = useSelector(state => state.accountTypes);
  const manageSavingDataObj = useSelector( (state) => state.manageSavingGoalDetailsObj);
  const [endDateErrorMsg, setEndDateErrorMsg] = useState("");
  const [targetDateErrorMsg, setTargetDateErrorMsg] = useState("");
  const [startDateErrorMsg, setStartDateErrorMsg] = useState("");
  
 
  const onEdit1 = (value, type, index) => {  
    setActiveIndex(index);  
  };

  const GetSavingAndSpendingBalance = async (CardKey) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_BALANACE_ALLOCATE(CardKey);
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) { 
       
            dispatch({
              type: "MAIN_BALANCE",
              payload: { mainBalance: responseJson.Response },
            });
          
      }
    } catch (error) {
      console.log("error", error);
    }
  }
 
  
  const datas = [
    {
      'title': 'savings goal',
      'value': SavingGaolName || Saving_Goal,
      'edit': 'Edit Savings Goal Name',
      'onEdit': () => onEdit1(SavingGaolName || Saving_Goal, "SavingGoalName", 1),
      "type": 'Name'
    },
    // {
    //   'title': 'goal total',
    //   'value': `$${SavingGaolAmount}`, 
    //   'edit': 'Edit Amount',
    //   'onEdit': () => onEdit1(SavingGaolAmount, "SavingGaolAmount", 2),
    //   "type": 'Amount'

    // },
    {
      'title': 'Amount Saving',
      'value': `$${AddedAmount}`,
      'edit': 'Edit Amount',
      'onEdit': () => onEdit1(AddedAmount, "AllocateFundAmount", 3),
      "type": 'Installments'

    },
    {
      'title': 'frequency',
      'value': DisplayText,
      'edit': 'Edit Frequency',
      'onEdit': () => onEdit1(DisplayText, "Frequency", 4),
      "type": 'Frequency'
    },
 
  ]

  const handleBackClick = () => {
    logFirebaseEvents("Allocate_Fund", "Back_Allocate_Fund_Save_Clicked", "Back_Allocate_Fund_Save_Clicked","", "")
    onBack("AllocateDateCard")
  }

  const handleSaveAlertsClick = async () => {
    logFirebaseEvents("Allocate_Fund", "Save_Allocate_Fund_Clicked", "Save_Allocate_Fund_Clicked","", "")
    if (!RequestObject.sms && !RequestObject.email) {
      setNotificationError('Choose Notification Type');
      return;
    }
    var modifiedData = {  
      goalName : SavingGaolName,
      // targetAmount : SavingGaolAmount,
      // isSms : NotificationTypeSMS,
      // isEmail :NotificationTypeEmail,
      fromAccount : AccountId,
      fromAccountType : AccountType,
      installmentAmount : AddedAmount,
      frequency : Code,
      frequencyType : Code == "OT" ? Code : "RC",
      // targetDate : StartDate == 'Invalid date' ?  "" :  moment(StartDate).format('YYYY-MM-DD') ,
      // startDate:selectedStartDate == 'Invalid stard date' ?  "" :  moment(StartDate).format('YYYY-MM-DD'),
      // endDate:selectedEndDate == 'Invalid end date' ?  "" :  moment(StartDate).format('YYYY-MM-DD')
    };

    if (Code === "OT") {
      modifiedData.startDate = StartDate == 'Invalid date' ?  "" :  moment(StartDate).format('YYYY-MM-DD');
    } else {
      modifiedData.startDate = selectedStartDate == 'Invalid start date' ?  "" :  moment(selectedStartDate).format('YYYY-MM-DD');
      modifiedData.endDate = selectedEndDate == undefined ?  "" :  moment(selectedEndDate).format('YYYY-MM-DD');
    }

       var allocateFundStatus = dateComparison(moment(StartDate).format('MMMM DD, YYYY'))
            if (allocateFundStatus === "Future") modifiedData.IsScheduledTransfer = true
            else modifiedData.IsScheduledTransfer = false
    const deviceId = await retrieveData('updatedDeviceId')
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);

    const url = SAVING_ALLOCATE_FUND_V2(savingsAccount.CardKey , goalKeyData);
    const response = await PostRequest(url, modifiedData, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      const isSpendingAccount = AccountType === "Spending";
      if (isSpendingAccount) {
        GetSavingAndSpendingBalance(AccountId)
      }

      onSave("success") 
      dispatch({ type: "RESET_ALLOCATE_FUND" })
      dispatch({ type: "RESET_SAVING_GOALS" })
    }else {

      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.MessageOrField;
      if (displayText ==="GoalNameExist") {
        onSave('existedName')
      }else{
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;

      dispatch({
        type: "ALLOCATE_FUND_RESPONSE_MSG",
        payload: { allocateFundResonseMsg: displayText },
      });
      onSave("error");
    }
    }
 
  }

  const setFrequencyFun = (value) => {
    setSelectedAccountType(value);
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: value },
    });
  };

  const onDateChange = (date) => {

    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 
    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setTargetDateErrorMsg(`The start date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else {
      setTargetDateErrorMsg("");
    }

    // if (Code === "OT") {
    //   const formattedDate = new Date(Date.parse(date));
    //   const currentDate = new Date();
    //   currentDate.setHours(0, 0, 0, 0);
    //   if (formattedDate.setHours(0, 0, 0, 0) === currentDate.getTime()) {
    //     setTargetDateErrorMsg(""); 
    //   } else {
    //     setTargetDateErrorMsg(`The start date must be current only (${currentDate.toLocaleDateString("en-US", {
    //       year: "numeric",
    //       month: "short",
    //       day: "numeric"
    //     })})`);
    //     return; 
    //   }
    // }

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "TargetDate", 'value': date } })
   
  }

  const onStartDateChange = (date) => {
    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 
    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setStartDateErrorMsg(`The start date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else {
      setStartDateErrorMsg("");
    }

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "StartDate", 'value': date } })
    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "EndDate", 'value': undefined } });
    setEndDateErrorMsg(""); 
  }

  const onEndDateChange = (date) => {
   
    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const startDateObj = selectedStartDate ? new Date(selectedStartDate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 
    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setEndDateErrorMsg(`The end date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else if (startDateObj && dateObj < startDateObj) {
      setEndDateErrorMsg("End date cannot be earlier than start date");
    } else {
      setEndDateErrorMsg("");
    }

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "EndDate", 'value': date } })
  }
  
  const [isEditingStates, setIsEditingStates] = useState([]);

  const handleSetIsEditingState = (index, isEditing) => {
    const updatedStates = [...isEditingStates];
    updatedStates[index] = isEditing;
    setIsEditingStates(updatedStates);
  };

  const isAnyItemEditing = isEditingStates.some((state) => state === true);

  console.log("error msg ", endDateErrorMsg)
  console.log("start date", selectedStartDate)
  console.log("end date", selectedEndDate)

  //  useEffect(() => {
     
  //   }, [ endDateErrorMsg]);
  
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div className='sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
         sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
              text-[var(--Great-Add-Spendsense)] mt-6 sm:mx-0 mx-4 sm:flex sm:flex-col '>
          <span>{t("spending_alert_confirm_content1")} </span>
          <span className='text-[var(--matter-add-spendSense)] lg:w-[590px] md:w-[590px] sm:w-[358px] 
          w-[264px]'>{addLineBreaks(t("Confirm_Your_Saving_Goal"))}</span>
        </div>

        <div className='w-full flex justify-center'>
          <div className="md:w-[80%] sm:w-[85%] w-full">
            {/* BODY */}
            <div className='lg:mb-[6rem] md:mb-[4rem] sm:mb-[3rem] mb-[4rem] sm:mx-0 mx-4'>
              <div className='sm:w-[80%] w-full flex flex-col justify-center'>
                {datas &&
                  datas.map((data, index) => {
                    return (
                      <AllocateFundSubItemConfirmationCard
                        key={index}
                        data={data}
                        onEdit={() => data.onEdit()}  
                        isActive={activeIndex === index}  
                        setIsEditingState={(isEditing) => handleSetIsEditingState(index, isEditing)}
                      />
                    )
                  })
                }
                <div className="md:mt-12 sm:mt-10 mt-12">
                  <CustomAllocateFundDropdown
                    options={
                      accountObj.length > 0
                        ? accountObj
                        : [{ Name: t("no_linked_acccounts") }]
                    }
                    title={t("Allocate funds from")}
                    onSelect={setFrequencyFun}
                    selectedAccountType={selectedAccountType}
                    selectedFrequency={AccountName}
                    hrbg="bg-dropdown-sky"
                  />
                </div>
                <div className="md:mt-12 sm:mt-10 mt-12">
                 
                  {Code === "OT" ?
                  (
                    <>
                    <CustomDatePicker
                    selectedDate={StartDate && !isNaN(new Date(StartDate)) ? StartDate : ''}
                    onDateChange={(date) => onDateChange(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="Start Date"
                    hrbg="bg-dropdown-sky"
                  />
                  <div className='my-2 w-full'>
                        {targetDateErrorMsg !== ""  &&  displayErrorMessage(targetDateErrorMsg)}
                     </div>
                     </>
                  ):(
                     <> 
                    <CustomDatePicker
                    selectedDate={selectedStartDate}
                    onDateChange={(date) => onStartDateChange(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="Start Date"
                    hrbg="bg-dropdown-sky"
                  />
                   <div className='my-2 w-full'>
                        {startDateErrorMsg !== ""  &&  displayErrorMessage(startDateErrorMsg)}
                     </div>

                  <div className="md:mt-12 sm:mt-10 mt-12">
                   <CustomDatePicker
                    selectedDate={selectedEndDate}
                    onDateChange={(date) => {onEndDateChange(date , "EndDate")
                    }}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="End Date (OPTIONAL)"
                    hrbg="bg-dropdown-sky"
                   />
                    <div className='my-2 w-full'>
                        {endDateErrorMsg !== ""  &&  displayErrorMessage(endDateErrorMsg)}
                     </div>
                   </div>
                     </>
                  )}
                </div>

                {/* <div className='md:mt-12 sm:mt-10 mt-12 md:w-[63%]'>
                 
                  <CustomRadioButton
                    title={t('spending_alert_notification_title')}
                    options={notificationArray}
                    onSelect={setNotificationFun}
                    fillIcon={checkbox_fill}
                    frequency={notificationArray}
                    nullIcon={appThemeData.isBatCheck}
                   error={NotificationError}
                  />
 

                  <span className="font-hanken-grotesk text-[12px] leading-[20px] text-[var(--pin-note-clr2)]
                font-normal">{t('sms_rating')}</span>
                </div> */}
              </div>
            </div>



          </div>
        </div>
        {/* FOOTER */}
        {cardFooter(handleBackClick, handleSaveAlertsClick, false, `${t("save")}`,!isAnyItemEditing && endDateErrorMsg === "" && startDateErrorMsg === "" && targetDateErrorMsg === "",styleForbuttons)}

        {/* ---------- */}
      </>
    )
  }
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        backgroundColor={'--cardHeading-bg'} 
                        HeaderContent={
                            <>
                                <CardHeading heading={t('Allocate_Funds')} />
                            </>
                        }
        footer={true}
         >
        {children()}
      </DynamicCard>

      {isLoading && <Loader />}
    </>
  )
}


export default withOidcSecure(AllocateConfirmationCard)


